import RotateOut from './rotate-out'
import RotateOutDownLeft from './rotate-out-down-left'
import RotateOutDownRight from './rotate-out-down-right'
import RotateOutUpLeft from './rotate-out-up-left'
import RotateOutUpRight from './rotate-out-up-right'

export default {
  RotateOut,
  RotateOutDownLeft,
  RotateOutDownRight,
  RotateOutUpLeft,
  RotateOutUpRight
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/rotating-exits/index.js